import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CATEGORIES, GALLERY } from "../../data";
import { useLang } from "../../i18n";

export const PortfolioGallery = () => {
  const { t } = useLang();
  const [active, setActive] = useState("All");
  const items = active === "All" ? GALLERY : GALLERY.filter((g) => g.cat === active);

  return (
    <section id="work" data-testid="work-section" className="px-6 md:px-12 py-28 md:py-40">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
        <div>
          <p className="overline text-[#E2725B] mb-5">{t.work.overline}</p>
          <h2 className="font-serif-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.9]">
            {t.work.t1} <span className="italic">{t.work.t2}</span>
          </h2>
        </div>
        <div className="flex flex-wrap gap-x-7 gap-y-3">
          {CATEGORIES.map((c) => (
            <button key={c} data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`} onClick={() => setActive(c)}
              className={`overline text-[0.66rem] relative pb-1 transition-colors ${active === c ? "text-[#E2725B]" : "text-[#2D2A26]/50 hover:text-[#2D2A26]"}`}>
              {t.work.cats[c] || c}
              {active === c && <motion.span layoutId="filter-underline" className="absolute -bottom-0.5 left-0 right-0 h-px bg-[#E2725B]" />}
            </button>
          ))}
        </div>
      </div>

      <motion.div layout className="columns-1 sm:columns-2 lg:columns-3 gap-5 md:gap-7 [column-fill:_balance]">
        <AnimatePresence mode="popLayout">
          {items.map((item) => (
            <motion.figure layout key={item.id} data-testid={`gallery-item-${item.id}`}
              initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
              className="group mb-5 md:mb-7 break-inside-avoid relative overflow-hidden rounded-sm cursor-pointer">
              <div className={`overflow-hidden ${item.ratio === "tall" ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
                <img src={item.url} alt={item.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#2D2A26]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <p className="font-serif-display italic text-2xl text-[#F9F6F0]">{item.title}</p>
                <p className="overline text-[0.55rem] text-[#F4D5C9] mt-1">{t.work.cats[item.cat] || item.cat} · {item.place}</p>
              </figcaption>
            </motion.figure>
          ))}
        </AnimatePresence>
      </motion.div>
    </section>
  );
};
